/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { forEachAncestorAndSelf } from 'app/shared/lib/dom';

const TEST_ID_ATTR = 'test-id';

@autoinject
export class TestIdService {

    /**
     * Does the specified `element` have a `test-id`
     * @param element
     */
    public hasId(element: Element): boolean {
        return !!element.getAttribute(TEST_ID_ATTR);
    }

    /**
     * Remove the `test-id` from the specified `element`
     * @param element
     */
    public clearId(element: Element): void {
        element.removeAttribute(TEST_ID_ATTR);
    }

    /**
     * Get the `test-id` of the specified element, or `''` if it does not have one
     * @param element
     */
    public getId(element: Element): string {
        return element.getAttribute(TEST_ID_ATTR) || '';
    }

    /**
     * Set the `test-id` on the specified `element`
     * @param element
     * @param id
     */
    public setId(element: Element, id: string): void {
        if(id) {
            element.setAttribute(TEST_ID_ATTR, id);
        }
        else {
            element.removeAttribute(TEST_ID_ATTR);
        }
    }

    /**
     * Get the full path, including the `test-id` of `element` and all its ancestors.
     * @param element
     */
    public getIdPath(element: Element): string[] {
        const path: string[] = [];
        forEachAncestorAndSelf(element, e => {
            const id = this.getId(e);
            if(id) { path.unshift(id); }
        });
        return path;
    }

}
